<template>
	<div class="google-map">
		<iframe
			v-if="address"
			class="google-map__iframe"
			frameborder="0"
			style="border:0"
			referrerpolicy="no-referrer-when-downgrade"
			:src="
				`https://www.google.com/maps/embed/v1/place?key=${mapKey}&zoom=17&q=${mapAddress}`
			"
			allowfullscreen
		>
		</iframe>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'GoogleMap',

	computed: {
		...mapState('venue', ['venueInfo']),

		mapKey() {
			return process.env.VUE_APP_GOOGLE_MAP_KEY
		},

		address() {
			return this.venueInfo.address
		},

		mapAddress() {
			return this.address
				? `${this.address.addressLine1} ${this.address.city},${this.address.region}`.replaceAll(
						' ',
						'+'
				  )
				: ''
		}
	}
}
</script>

<style lang="scss" scoped>
.google-map {
	border-radius: 24px;
	overflow: hidden;

	&__iframe {
		width: 100%;
		height: 100%;
		filter: invert(90%) grayscale(1);
	}
}
</style>
